var cities = {
    async get( cityName) {
        console.log("will get city" + cityName)
        const db = window.firebase.firestore();
        let objects = [];
        var e = await db.collection("/cities")
        .where("name", "==", cityName).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var d = doc.data();
            d.id = doc.id;
            objects.push(
              doc.data()
            );
            console.log(doc.id, " => ", doc.data());
          });
          console.log("will return")
          console.log(JSON.stringify(objects))
          return objects[0];
        })
          .catch((error) => {
            console.log("Error getting documents: ", error);
            return error;
          });


          e.stateName = e.name.substring( e.name.length-2,  e.name.length);
      
        return e;
      },
  
}
export default cities;